<div class="container-fluid py-4 bg-light min-vh-100">
  
  <!-- Header -->
  <div class="d-flex justify-content-between align-items-center mb-4 px-2">
    <div>
      <h2 class="fw-bold mb-0 text-dark"><i class="bi bi-card-checklist text-primary me-2"></i>Reportes de Inspección</h2>
      <p class="text-muted mb-0">Auditoría y gestión de las revisiones técnicas de bicicletas</p>
    </div>
  </div>

  <!-- Controles: Dropdown de Meses y Buscador Global -->
  <div class="card border-0 shadow-sm rounded-24 mb-4">
    <div class="card-body p-3">
      <div class="row align-items-center g-3">
        
        <!-- Selector de Meses -->
        <div class="col-md-4 col-lg-3">
          <label class="form-label small fw-bold text-muted ms-1 mb-1">Filtrar por Mes</label>
          <select class="form-select rounded-pill bg-light border-0 py-2" [formControl]="selectedMonthControl">
            <option *ngFor="let m of availableMonths" [value]="m.value">{{ m.label }}</option>
          </select>
        </div>

        <!-- Buscador Global -->
        <div class="col-md-8 col-lg-9">
          <label class="form-label small fw-bold text-muted ms-1 mb-1">Búsqueda Global (Toda la base de datos)</label>
          <div class="input-group bg-light rounded-pill px-2 border">
            <span class="input-group-text border-0 bg-transparent text-muted"><i class="bi bi-search"></i></span>
            <input type="text" class="form-control border-0 bg-transparent py-2 shadow-none" 
                   placeholder="Buscar N° Orden (TRB-15), Cliente o Bici..." 
                   [formControl]="searchControl"
                   (keyup.enter)="triggerSearch()">
            <button *ngIf="searchControl.value" class="btn border-0 text-muted" (click)="clearSearch()" title="Limpiar búsqueda">
              <i class="bi bi-x-circle-fill"></i>
            </button>
            <button class="btn btn-primary rounded-pill px-4 my-1 ms-1 shadow-sm" (click)="triggerSearch()">
              Buscar
            </button>
          </div>
        </div>
        
      </div>
    </div>
  </div>

  <!-- Etiqueta de Contexto de Visualización -->
  <div class="mb-3 px-2 d-flex justify-content-between align-items-center">
    <span class="badge bg-primary-subtle text-primary border border-primary-subtle px-3 py-2 rounded-pill fw-bold">
      <i class="bi" [ngClass]="isSearching ? 'bi-search' : 'bi-calendar-event'"></i> 
      {{ isSearching ? 'Resultados de Búsqueda Global' : 'Inspecciones del Mes Seleccionado' }}
    </span>
    <span class="text-muted small fw-bold">{{ inspections.length }} resultados</span>
  </div>

  <!-- Lista / Tabla -->
  <div class="card border-0 shadow-sm rounded-24 overflow-hidden">
    <div class="card-body p-0">
      
      <!-- Cargando -->
      <div *ngIf="isLoading" class="text-center py-5">
        <div class="spinner-border text-primary mb-3" role="status"></div>
        <h6 class="text-muted">Analizando base de datos...</h6>
      </div>

      <!-- Tabla de Resultados -->
      <div class="table-responsive" *ngIf="!isLoading">
        <table class="table table-hover align-middle mb-0">
          <thead class="bg-dark text-white">
            <tr class="small text-uppercase fw-bold">
              <th class="ps-4 py-3">N° Orden</th>
              <th>Cliente</th>
              <th>Bicicleta</th>
              <th>Fecha Inspección</th>
              <th class="text-center pe-4">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of inspections" class="transition-all">
              
              <!-- Orden -->
              <td class="ps-4">
                <span class="badge bg-light text-dark border font-monospace fs-6 px-2 py-1">
                  {{ item.work.caseNumber }}
                </span>
              </td>
              
              <!-- Cliente -->
              <td>
                <div class="fw-bold text-dark">{{ item.work.clientName }}</div>
              </td>
              
              <!-- Bicicleta -->
              <td>
                <div class="small text-muted text-truncate" style="max-width: 250px;" title="{{ item.work.bikeDescription }}">
                  <i class="bi bi-bicycle me-1"></i> {{ item.work.bikeDescription }}
                </div>
              </td>
              
              <!-- Fecha -->
              <td>
                <span class="text-muted small fw-medium">
                  {{ item.inspection.createdAt?.toDate() | date:'mediumDate':'':'es-DO' }}
                </span>
              </td>
              
              <!-- Salud E-Bike -->

              <!-- Acciones -->
              <td class="text-center pe-4">
                <div class="btn-group shadow-sm rounded-pill overflow-hidden">
                  <button class="btn btn-sm btn-outline-primary px-3" (click)="editInspection(item.work.caseNumber!)" title="Ver / Editar">
                    <i class="bi bi-pencil-square"></i>
                  </button>
                  <button class="btn btn-sm btn-outline-danger px-3" (click)="deleteInspection(item.work.id!, item.work.caseNumber)" title="Eliminar">
                    <i class="bi bi-trash-fill"></i>
                  </button>
                </div>
              </td>

            </tr>
            
            <!-- Empty State -->
            <tr *ngIf="inspections.length === 0">
              <td colspan="6" class="text-center py-5 text-muted">
                <i class="bi bi-search-heart display-4 d-block mb-3 opacity-25"></i>
                <h5 *ngIf="isSearching">No se encontraron reportes para "{{ searchControl.value }}" en todo el historial.</h5>
                <h5 *ngIf="!isSearching">No se han realizado inspecciones en el mes seleccionado.</h5>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>
</div>